import React, { useEffect, useState } from 'react';
import { notificationErrorSVG, notificationSuccessSVG, notificationInfoSVG, notificationWarningSVG, notificationCloseSVG } from '../../helpers/icons';
import SVG from 'react-inlinesvg';
import styles from './customToast.module.scss';
import { useTranslation } from 'react-i18next';

const CustomToast = ({ type = 'warning', message = "Mensaje...", onClick, icon, title, className, iconStyle, bottomActions, hideTitle = true }) => {
    const { t } = useTranslation('notification');

    const toastTypes = {
        error: {
            icon: notificationErrorSVG,
            backgroundColor: "#FFDBDB",
            title: t('error_title', 'Error'),
        },
        warning: {
            icon: notificationWarningSVG,
            backgroundColor: "#FFF9E6",
            title: t('warning_title', 'Warning'),
            borderColor: '#FFC15E'
        },
        info: {
            icon: notificationInfoSVG,
            backgroundColor: "#EBF3FE",
            title: t('info_title', 'Information'),
            borderColor: '#3F87F5'
        },
        success: {
            icon: notificationSuccessSVG,
            backgroundColor: "#C0EFD8",
            title: t('success_title', 'Success'),
        }
    };

    const [toastStyle, setToastStyle] = useState(toastTypes['warning']);

    useEffect(() => {
        if (type) {
            setToastStyle(toastTypes[type]);
        }
        else {
            setToastStyle(toastTypes['warning']);
        }
    }, [type]);

    return (
        <div
            onClick={onClick}
            className={`${styles.customToastContainer} ${className}`}
            style={{
                backgroundColor: toastStyle.backgroundColor,
            }}
        >
            <SVG className={`${styles.icon} ${iconStyle}`} src={icon ?? toastStyle.icon} />
            <div className={`${styles.messageContainer} ${bottomActions && styles.bottomActions}`}>
                {(!hideTitle && (title || toastStyle.title)) && <span>{title ?? toastStyle.title}</span>}
                <p>{message}</p>
                {bottomActions &&
                    <div className={styles.buttonsContainer}>
                        {bottomActions}
                    </div>


                }
            </div>
            <SVG className={`${styles.closeIcon}`} src={notificationCloseSVG} />
        </div>
    )
}

export default CustomToast;